import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex min-h-[17px] min-w-5 items-center justify-center gap-[1px] rounded-full border-1 border-white text-center leading-none',
    prefix: ''
  },
  variants: {
    color: {
      primary: 'bg-primary text-contrast',
      yellow: 'bg-accent text-primary',
      light: 'bg-accent text-primary'
    },
    size: {
      small: {
        base: 'px-1 text-[10px]'
      },
      big: {
        base: 'px-2 text-[14px]'
      }
    }
  },
  defaultVariants: {
    color: 'primary',
    size: 'small'
  }
});
